/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconProfileBirthname = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M6.999 15.98a.488.488 0 0 1-.145-.023c-1.755-.585-2.73-2.996-2.298-4.56a.461.461 0 0 1 .65-.288l2 1a.459.459 0 0 1 .157.693c-.654.845-.184 2.04.05 2.516a.461.461 0 0 1-.414.663zM8.913 15.98a.461.461 0 0 1-.413-.662c.233-.476.704-1.673.05-2.516a.464.464 0 0 1 .157-.694l2-1a.462.462 0 0 1 .65.288c.433 1.563-.543 3.975-2.298 4.56a.46.46 0 0 1-.146.023zM14.67 9.435c-1.366-2.716-4.39-3.371-4.518-3.397-.028-.006-.055.002-.083-.001a.73.73 0 0 0-.526.149 3.55 3.55 0 0 1-3.088 0 .726.726 0 0 0-.521-.15c-.029.003-.057-.006-.087 0-.128.026-3.151.682-4.518 3.397a.75.75 0 1 0 1.34.674c.569-1.131 1.551-1.793 2.33-2.17l-.475 1.424c-.051.152-.025.31.069.44s.244.198.405.198h6.02c.276 0 .36-.131.439-.268.088-.154.027-.351-.025-.498l-.435-1.304c.778.374 1.758 1.036 2.332 2.177a.751.751 0 1 0 1.34-.673zM8.001.5C7.077.5 6 1.078 6 1.907L6.002 3 6 4.066c0 .808 1.078 1.372 2.001 1.372S10 4.783 10 3.975V2.001C10 1.172 8.925.5 8.001.5z"
    />
  </svg>
);

IconProfileBirthname.displayName = 'IconProfileBirthname';

IconProfileBirthname.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconProfileBirthname);
IconProfileBirthname.displayName = 'IconProfileBirthname';
